import { GridOptions, ISetFilterParams, RowStyle } from '@ag-grid-community/core';

import {
  AgRawMultiTooltip,
  AgRawMultiTooltipValues,
} from '@shared/components/ag-raw-tooltip/ag-raw-multi-tooltip';
import { TableConstants } from '@shared/constants/table.constants';
import { AuxExcelStyles } from '@shared/utils/aux-excel-styles/aux-excel-styles';
import { Utils } from '@shared/utils/utils';

import { forcedTooltip } from './balance-sheet-account-row-data.util';

export const DEFAULT_BALANCE_SHEET_ACCOUNTS_GRID_CONFIG: GridOptions = {
  ...TableConstants.DEFAULT_GRID_OPTIONS.GRID_OPTIONS,
  defaultColDef: {
    ...TableConstants.DEFAULT_GRID_OPTIONS.DEFAULT_COL_DEF,
    cellClass: 'cursor-not-allowed',
    filter: true,
    filterParams: {
      showTooltips: true,
    } as ISetFilterParams,
    menuTabs: ['filterMenuTab'],
    minWidth: 100,
    resizable: true,
    sortable: true,
    suppressMenu: false,
    tooltipComponent: AgRawMultiTooltip,
    tooltipValueGetter: () =>
      <AgRawMultiTooltipValues>[
        {
          type: 'overflow',
          use: 'value',
        },
        {
          type: 'force-tooltip',
          value: forcedTooltip,
        },
      ],
  },
  enableRangeSelection: true,
  excelStyles: [...Utils.generateExcelCurrencyStyles(Utils.CURRENCY_OPTIONS), ...AuxExcelStyles],
  getRowStyle: (params) => {
    if (params.node.isRowPinned()) {
      return <RowStyle>{ '--ag-row-height': '40px' };
    }

    return {};
  },
  headerHeight: 48,
  noRowsOverlayComponent: TableConstants.NO_ROWS_MESSAGE,
  rowHeight: 40,
  suppressAggFuncInHeader: true,
  suppressCellFocus: false,
  suppressMenuHide: true,
  tooltipShowDelay: 0,
};
